// bundle-builder.js
export default (Alpine) => {
    Alpine.data("benefitAccordion", (blogHandle) => ({
        accordionItems: [],

      
      init() {

        this.accordionItems = document.querySelectorAll('.benefit-accordion');

      },

      toggleAccordion(e) {
        e.preventDefault();
        const eventTarget = e.currentTarget;
        const isOpen = eventTarget.hasAttribute('open');

        this.accordionItems.forEach(item => {
            // item !== eventTarget || item.hasAttribute('open') ? item.classList.remove('open') : null;
            // isOpen ? eventTarget.classList.remove('open') : eventTarget.classList.add('open');
            
          // setTimeout(() => {
            item !== eventTarget || item.hasAttribute('open') ? item.removeAttribute('open') : null;
            isOpen ? eventTarget.removeAttribute('open') : eventTarget.setAttribute('open', true);
          // }, 200);
        });

      },

    }));
  };